import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAcPTRig04qXdlk3aZ49jMFtz8XU51gYIM",
  authDomain: "breakfast-blog.firebaseapp.com",
  projectId: "breakfast-blog",
  storageBucket: "breakfast-blog.firebasestorage.app",
  messagingSenderId: "374989411246",
  appId: "1:374989411246:web:445d6effbb6455ccbeae3f",
  measurementId: "G-52BMTZKYHT"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
